module.exports = __webpack_public_path__ + "img/mizhi-back-two@2x.7a7fad8a.png";